// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1dea6ff7ff3d909edc9a","655":"a63c1eef5ce301983923"}[chunkId] + ".js";
};